import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Button, Pane, toaster } from 'evergreen-ui';
import { CalendarManager } from '../appservices/AppManager';

const localizer = momentLocalizer(moment);

const CalendarView = ({ baseUrl, calendarId }) => {
  const [events, setEvents] = useState([]);
  const calendarManager = new CalendarManager(baseUrl);

  // Fetch events from the backend
  const fetchEvents = async () => {
    try {
      const eventList = await calendarManager.listEvents(calendarId);
      const formattedEvents = eventList.map((event) => ({
        id: event.id,
        title: event.subject || 'No Title',
        start: new Date(event.start.dateTime),
        end: new Date(event.end.dateTime),
      }));
      setEvents(formattedEvents);
    } catch (error) {
      toaster.danger('Failed to load events', { description: error.message });
    }
  };

  // Create a sample event
  const createEvent = async () => {
    const newEvent = {
      subject: 'Sample Event',
      start: { dateTime: moment().add(1, 'hour').toISOString(), timeZone: 'UTC' },
      end: { dateTime: moment().add(2, 'hours').toISOString(), timeZone: 'UTC' },
    };
    try {
      await calendarManager.manageEvents(calendarId, 'create', null, newEvent);
      toaster.success('Event created successfully');
      await fetchEvents(); // Refresh events
    } catch (error) {
      toaster.danger('Failed to create event', { description: error.message });
    }
  };

  // Update an event
  const updateEvent = async (eventId) => {
    const updatedEvent = {
      subject: 'Updated Event Title',
    };
    try {
      await calendarManager.manageEvents(calendarId, 'update', eventId, updatedEvent);
      toaster.success('Event updated successfully');
      await fetchEvents(); // Refresh events
    } catch (error) {
      toaster.danger('Failed to update event', { description: error.message });
    }
  };

  // Delete an event
  const deleteEvent = async (eventId) => {
    try {
      await calendarManager.manageEvents(calendarId, 'delete', eventId);
      toaster.success('Event deleted successfully');
      await fetchEvents(); // Refresh events
    } catch (error) {
      toaster.danger('Failed to delete event', { description: error.message });
    }
  };

  // Fetch events on component mount
  useEffect(() => {
    if (calendarId) {
      fetchEvents();
    }
  }, [calendarId]);

  return (
    <Pane>
      <Pane marginBottom={16}>
        <Button appearance="primary" marginRight={8} onClick={fetchEvents}>
          Refresh Events
        </Button>
        <Button appearance="primary" intent="success" marginRight={8} onClick={createEvent}>
          Create Sample Event
        </Button>
      </Pane>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
      />
      <Pane marginTop={16}>
        {events.map((event) => (
          <Pane key={event.id} borderBottom="muted" padding={8}>
            <strong>{event.title}</strong> <em>({moment(event.start).format('LLL')})</em>
            <Button
              appearance="minimal"
              intent="none"
              onClick={() => updateEvent(event.id)}
              marginLeft={8}
            >
              Update
            </Button>
            <Button
              appearance="minimal"
              intent="danger"
              onClick={() => deleteEvent(event.id)}
              marginLeft={8}
            >
              Delete
            </Button>
          </Pane>
        ))}
      </Pane>
    </Pane>
  );
};

export default CalendarView;
